import axios from 'axios';

export class CustomerFeedbackHttpClient {
    async getFeedbackByProducts(productIds, page) {
        const url = `/app/feedback.php?action=get_product_feedback&product_ids=${productIds.join(',')}&page=${page}`;
        const { data } = await axios.get(url);

        return data;
    }
}